import React, { ReactNode } from "react";
import AppHeader, { AppHeaderProps } from "@components/page/header/AppHeader";
import FooterInternal from "@components/page/footer/FooterInternal";
import { MainContainer } from "@helpers/style/global.styles";

interface IProps extends AppHeaderProps {
  children: ReactNode;
}

const PageContainer: React.FC<IProps> = ({
  children,
  title,
  ...headerProps
}) => {
  return (
    <>
      <AppHeader {...headerProps} title={title ?? "Dashboard"} />
      <MainContainer>{children}</MainContainer>
      <FooterInternal />
    </>
  );
};

export default PageContainer;
